import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Help, StringHelpers, SystemText } from 'e4shared';
import { apiGet, apiPatch, apiPost } from '../../../services';

import './like.css';

export const Like = ({ disabled, entity, id, small, name, owner_Id, onLike }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const guid = useSelector(state => state.user.user.guid);

    const gotResponse = response => {
        setData(response);
        setLoading(false);
    };

    const load = React.useCallback(
        reload => {
            entity &&
                id &&
                guid &&
                Number.isInteger(id) &&
                apiGet(`like/${entity}/${id}`, guid, response => gotResponse(response));

            reload && onLike && onLike();
        },
        [entity, id, guid, onLike]
    );

    React.useEffect(() => {
        load();
    }, [entity, id, guid, load]);

    const hasLiked = data?.some(l => l.isMe);

    const likeUnlike = () => {
        setLoading(true);
        const like = { entity, entity_Id: id, owner_Id };
        if (hasLiked) {
            apiPatch(`like`, like, guid, () => load(true));
        } else {
            apiPost(`like`, like, guid, () => load(true));
        }
    };

    const icon = loading ? <i className="fa fa-spin fa-cog mr10" /> : <i className="fa fa-thumbs-up mr10" />;
    return (
        <span data-testid="like">
            {hasLiked && (
                <button
                    className={`btn btn-success btn-${small ? 'x' : ''}xs mr10`}
                    title={SystemText('General/Like/RemoveLikePopup')}
                    disabled={disabled}
                    onClick={() => likeUnlike()}
                >
                    {icon}
                    {SystemText('General/Like/Liked')}
                </button>
            )}
            {!hasLiked && (
                <button
                    className={`btn btn-info btn-${small ? 'x' : ''}xs mr10`}
                    disabled={disabled}
                    title={SystemText('General/Like/AddLikePopup', name)}
                    onClick={() => likeUnlike()}
                >
                    {icon}
                    {SystemText('General/Like/Like')}
                </button>
            )}
            {!loading && (
                <span>
                    {data?.length} {StringHelpers.pluralise(SystemText('General/Like/LikeCount'), data?.length)}
                </span>
            )}
            {data && data.length > 0 && <Help id={`likes-${entity}-${id}`}>{data.map(d => d.full_Name).join(', ')}</Help>}
        </span>
    );
};

export default Like;
